import { Metamodel } from 'app/model/base/model';
import { FormatReadSettings } from './format-read-settings';
import { IAttribute, JsonDataset } from 'shell-models-lib';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.json.formatRead,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(JsonDataset) }
})
export class JsonFormatReadSettings extends FormatReadSettings {
    public static readonly DOCUMENT_FORM: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'DOCUMENT_FORM',
        display: stringResources.DataFlowSourceSettingsDocumentFormLabel
    })
    public documentForm?: string;
}
